// eslint-disable-next-line func-names
export default function (meta, formDirtySinceLastSubmit) {
  if (!meta.touched) {
    return false;
  }

  if (meta.error) {
    return true;
  }

  if (meta.submitError && !meta.dirtySinceLastSubmit && !formDirtySinceLastSubmit) {
    return true;
  }

  return false;
}